/**
 * MediaImage component that loads images with authentication
 */

import { useMediaUrl } from "../../hooks/useMediaUrl";

interface MediaImageProps {
  mediaId: number;
  alt: string;
  className?: string;
  onClick?: () => void;
  /** Change this value to force a reload (e.g., after rotation/crop) */
  cacheBuster?: number;
}

export function MediaImage({ mediaId, alt, className, onClick, cacheBuster }: MediaImageProps) {
  const { url, isLoading, error } = useMediaUrl(mediaId, cacheBuster);

  if (isLoading) {
    return (
      <div className={`flex items-center justify-center bg-vault-100 ${className}`}>
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-vault-300 border-t-vault-600" />
      </div>
    );
  }

  if (error || !url) {
    return (
      <div className={`flex items-center justify-center bg-vault-100 text-vault-400 ${className}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-12 w-12"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
          />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onClick={onClick}
    />
  );
}
